module.exports = __webpack_public_path__ + "img/road2h.c43e17de.png";